
import React from 'react';
import { dateTimeFormatOptions } from '../types';
import { DateTimeFormatInput, DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';


export const IntlDateTimeFormatFormatToParts = () => (
	<IntlFunction
		input={DateTimeFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts"
		header="Intl.DateTimeFormat.prototype.formatToParts"
		description="Allows locale-aware formatting of strings produced by [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) formatters."
		options={dateTimeFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="new Intl.DateTimeFormat(##locale##, ##options##).formatToParts(##input:raw##)" />
)

